import React from "react";

import { GroupProps } from "./Group.types";
import * as Styled from "./Group.styled";

export const Group: React.FC<GroupProps> = ({
  title,
  children,
  as = "div",
}) => {
  return (
    <Styled.Root as={as}>
      <Styled.Title>{title}</Styled.Title>
      {children}
    </Styled.Root>
  );
};
